import { Navigate } from 'react-router-dom';
import { DashboardAdvancedPanel, DashboardSaveBar } from '@/components/dashboard/DashboardPanels';
import { useDashboardSite } from '@/pages/dashboard/DashboardSiteContext';

export default function DashboardAdvancedPage() {
  const { isPlatformAdmin } = useDashboardSite();
  if (!isPlatformAdmin) return <Navigate to="/dashboard" replace />;
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold">Advanced</h2>
        <p className="text-sm text-muted-foreground">Raw revenue config (platform admin only).</p>
      </div>
      <DashboardAdvancedPanel />
      <DashboardSaveBar />
    </div>
  );
}
